import FeaturesCardStyleWrapper from "./FeaturesCard.style";

const FeaturesCard = ({ title, icon, text }) => {
  return (
    <FeaturesCardStyleWrapper className="about_us_text_card">
      <img src={icon} alt="" />
      <h3>{title}</h3>
      <p>{text}</p>
    </FeaturesCardStyleWrapper>
  );
};

export default FeaturesCard;
